import { AppHelper } from "../appHelper";
import { Dialog, DialogAction, DialogProps } from "../core/components/dialog";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter";
import { ListBox } from "../core/components/listBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { Commands } from "../core/util/commandManager";
import { ResourcePlanningHelper } from "../core/util/resourcePlanningHelper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { DocumentPreview } from "../documents/documents";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { FieldInstance } from "../core/components/field";
import { DialogHelper } from "../core/util/dialogHelper";
import { GeomapService } from "../geomap/geomapService";
import { IsSearchField } from "../core/components/isSearchField";
import { DropDownList } from "../core/components/dropDownList";
import TimeZoneSummary from "./timezoneSummary";
import { HTTPRequestConfig, HTTPRequestType, HTTPService, JsonResultClass } from "../core/util/httpManager";
import ServerTemplateExecuteApp from "../serverTemplate/serverTemplateExecute";
import { EventType } from "../../siteManagement/eventManager";
import { FAIcon } from "../core/components/faIcon";
import {
    ResourcePlaningGroupingHelper,
    ResourcePlanningGroupingDialog,
    ResourcePlanningGroupingDialogProps
} from "../resourcePlanningGrouping/resourcePlanningGrouping";
import { ModalHelper } from "../../siteManagement/showmodal";
import TraveldataSummary from "./traveldataSummary";
import Skills from "../core/components/skills";
import { SkillHelper } from "../generalSettings/skills/skillsHelper";
import { Util } from "../resourcePlanningScheduler/utils";
import { SplittingDialogResult, SplittingDialogUtil } from "../resourcePlanningScheduler/splittingDialog/util";
import { OpenResourcePlanningDeletionDialog } from "../resourcePlanningDialogs/resourcePlanningDeletionDialog";
import { OpenResourcePlanningMovingDialog } from "./dialogs/resourcePlanningMovingDialog";
import { OpenResourcePlanningResetSendStateDialog } from "./dialogs/resourcePlanningRevokeSendStateDialog";
import { SkillCategory, TreeNodeVm } from "../generalSettings/skills/skillsInterfaces";
import { PageTitleProps } from "../core/components/pageTitle";
import { AssignmentUtilizationInfo } from "../resourcePlanningScheduler/resourcePlanningScheduler";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export default class ResourcePlanningApp extends React.Component<ResourcePlanningAppProps, ResourcePlanningState> {
    common = new AppHelper();
    private listboxRef: ListBox = null;
    private factory = ComponentHelper.createFactory();
    private defined = Helper.hasValue;
    private lockId: number;
    private listTotalItems = [];
    private listRemoveItems = [];
    private listNotRemoveItems = [];
    private geomapService = new GeomapService();
    protected isMultipleDaysAssignment: null | boolean = null;
    private downloadBtnId = "DOWNLOAD";
    private previewBtnId = "PREVIEW";
    private openLinkBtnId = "OPEN_ID";
    private selectAllId = "SELECT_ALL";
    private deselectAllId = "DESELECT_ALL";

    showAlternateCommentField: boolean = true;
    resourceSearchUrl = "DynamicSearch/Window/Resource?withSkills=true&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus";
    showPMLink = false;
    addressSearchEnabled = false;
    projectSearchEnabled = false;
    geomapEnabled = false;
    translations: StringKeyDictionary<string> = {};
    assignmentCodesDS = [];
    timeZonesEnabled = false;
    approvalEnabled = false;
    articleGridOptions: {};
    machineGridOptions: {};
    documentsToBeSendGridOptions: {};
    saveSheetTitle: string = null;
    isSysAdmin: boolean;
    disableSendState: boolean = false;
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    private oldData = null;
    private oldStart = null;
    private oldEnd = null;
    private oldId = null;
    private oldResourceId = null;
    protected onlyHomewardJourney: boolean = false;
    deleteEnabled = false;
    isDeleted = false;
    //  private _dummy_settings = { ShowAssignmentsWithTimeZones: false, TimeResolutionType: 1, FilterContainerWithEvents: false } as ResourcePlanningSchedulerSettingsViewModel;

    private actions: Array<DialogAction> = [];
    private internalData = {
        previousCode: null,
        projectRequired: false,
        addressRequired: false,
        initThenEnter: false,
        initThenExit: false,
        existingProjectTriggered: false
    };

    private approvalConfig: ApprovalRequirements = {
        Level: 0,
        Period: false,
        Resource: false,
        Texts: false,
        ProjectLevelUsed: false
    };
    private approvalResetNeeded = false;
    private approvalResetNeededFromCode = false;
    private convertedTimesDialogOptions: Array<DialogAction> = [
        {
            action: () => {
                this.setState({ showConvertedTimesDialog: false });
            },
            label: Config.translations.ok,
            primary: true
        }
    ];
    private changeAddressDialogActions: Array<DialogAction> = [
        {
            label: Config.translations.cancel,
            action: () => {

            }
        },
        {
            label: Config.translations.ok,
            action: () => {
                if (!Helper.isNullOrEmpty(this.state.changeAddressDialog.adrNr)) {
                    let newEntity: ResourcePlanningEntity = JSON.parse(JSON.stringify(this.props.entity));
                    newEntity.AdrNr = this.state.changeAddressDialog.adrNr;
                    Helper.updateEntity(this.props.entity, newEntity);
                    this.reloadExpenses(newEntity.AdrNr).then(() => {
                        this.executeSave(false).then(_ => { });
                    });
                } else {
                    return false;
                }
            },
            primary: true
        }
    ];

    assignmentGroupingActive = false;
    copyRessourceGroupingActive = false;

    constructor(props: ResourcePlanningAppProps) {
        super(props);

        this.updateResourceSearchURL();
        this.assignmentGroupingActive = this.props.configData.assignmentGroupingActive;
        this.copyRessourceGroupingActive = this.props.configData.copyRessourceGroupingActive;
        this.isSysAdmin = Config.user.isSysAdmin;

        this.common.enableHooks = true;
        this.common.init(this);
        this.setPmShow();

        this.refreshDeleteEnabled();
        this.state = {
            showDialog: false,
            showConvertedTimesDialog: false,
            rebook: {
                showDialog: false,
                projNr: "",
                newKNr: null
            },
            changeAddressDialog: {
                showDialog: false,
                adrNr: props.entity.AdrNr
            },
            movedGroupingArray: null,
            skillsChanged: false,
            currentSkills: null,
            selectedDocsToSend: [],
            showPreview: false
        };
        Helper.saveDataToStorage("maxEndDate", props.entity.Arbeitsende, false);
        this.initApp().then(_ => { });
    }

    private updateResourceSearchURL = () => {
        let url = "DynamicSearch/Window/Resource?withSkills=true&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus";
        if (Helper.hasValue(this.props.entity.GrNr) && Helper.isNullOrEmpty(this.props.entity.RessNr)) {
            url += "&grnr=" + this.props.entity.GrNr;
        }
        if (Helper.hasValue(this.props.entity.OGrNr)) {
            url += "&ogrnr=" + this.props.entity.OGrNr;
        }
        if (Helper.hasValue(this.props.entity.IsGuid)) {
            url += "&eventIsGuids=" + this.props.entity.IsGuid;
        }
        this.resourceSearchUrl = url;
    }

    private setPmShow = () => {
        this.showPMLink = this.props.configData.pmLink > 0 && !Helper.isNullOrEmpty(this.props.entity.ProjNr) && (this.props.entity.KennungTyp === 5 || this.props.entity.KennungTyp === 6);
    }

    private handleDisableSendState = async () => {
        if (Config.settings.resetSendStateAtDTSChange && !this.props.entity.IsContainerEinsatz && !this.disableSendState && Config.settings.updateSendStatusWhenChangingAssignment == 0) {
            this.disableSendState = true;
            if (Config.settings.sendStateAtDTSChange != this.props.entity.Statussend) {
                NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.SendStateWasResetted"))
                await this.handleFieldChange({ model: "entity.Statussend" }, Config.settings.sendStateAtDTSChange)
            }
        }
    }

    private refreshSendState = async () => {
        const result = await HTTPService.get<JsonResultClass<ResourcePlanningEntity>>(`ResourcePlanning/GetAssignmentVm?projNr=${encodeURIComponent(this.props.entity.ProjNr)}&pIndex=${encodeURIComponent(this.props.entity.PIndex)}`);
        if (result.Code == 0) {
            if (this.props.entity.Statussend != result.Data.Statussend) {
                this.props.entity.Statussend = result.Data.Statussend;
                NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.SendStateWasResetted"));
                this.setState({});
            }
        }
    }

    private addApproval = () => {
        if (this.approvalEnabled && this.props.configData.approvalLevel > this.props.entity.Approvals) {
            DialogHelper.confirm(this.translations["WebSMS.ResourcePlanning.ShouldIncreaseApproval"].replace("{projNr}", this.props.entity.ProjNr).replace("{pIndex}", this.props.entity.PIndex.toString())).then(isOk => {
                if (isOk) {
                    this.props.entity.Approvals++;
                    HTTPService.get<JsonResultClass>("ResourcePlanning/SetApproval?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + this.props.entity.PIndex + "&level=" + this.props.entity.Approvals)
                        .then(result => {
                            if (result.Code > 0) {
                                NotificationHelper.showErrorMessage(result.Message);
                                this.props.entity.Approvals--;
                            } else {
                                NotificationHelper.showSuccessMessage(result.Message);
                                this.setState({}, this.markApprovalFieldLabels);
                            }
                        });
                }
            });
        }
    }

    private getApprovalConfig = (projNr: string, knr: number, afterSuccessCallback?: () => void) => {
        if (this.defined(projNr) || (this.defined(knr) && knr.toString() !== "" && knr.toString() !== "null")) {
            HTTPService.get<JsonResultClass>(
                "ResourcePlanning/GetApprovalRequirements?"
                + (this.defined(projNr) ? "projNr=" + encodeURIComponent(projNr) : "")
                + (this.defined(projNr) && this.defined(projNr) ? "&" : "")
                + (this.defined(knr) && knr.toString() !== "" && knr.toString() !== "null" ? "knr=" + knr : "")
            ).then(result => {
                if (result.Code > 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                } else {
                    this.approvalConfig = result.Data;
                    this.approvalEnabled = this.approvalEnabled = !this.props.entity.IsNew && this.approvalConfig.Level > 0;
                    if (this.approvalEnabled && (!this.defined(this.props.entity.Approvals) || this.props.entity.Approvals < 0)) {
                        this.props.entity.Approvals = 0;
                    }
                    this.setState({}, () => {
                        this.markApprovalFieldLabels();
                        if (this.defined(afterSuccessCallback)) {
                            afterSuccessCallback();
                        }
                    });
                }
            });
        }
    }

    private handleApprovalFieldChange = (field: ApprovalFields) => {
        const resetRequired = this.approvalEnabled && this.props.entity.Approvals > 0;

        if (resetRequired) {
            let showWarning = false;

            if (this.approvalConfig.Period && (field === ApprovalFields.PeriodEnd || field === ApprovalFields.PeriodStart)) {
                showWarning = true;
            }

            if (this.approvalConfig.Resource && field === ApprovalFields.Resource) {
                showWarning = true;
            }

            if (this.approvalConfig.Texts && (field === ApprovalFields.TextActivity || field === ApprovalFields.TextRemark)) {
                showWarning = true;
            }

            this.approvalResetNeeded = showWarning;
        }
    }

    private markApprovalFieldLabels = () => {
        if (!Config.settings.approvalProcessActive)
            return;
        let resetSelector = [];
        let markSelector = [];
        const getSelector = (propName: string) => {
            return `.field-instance[data-model='entity.${propName}'] .field__value__label label`;
        }
        const shouldShow = this.approvalEnabled && this.props.entity.Approvals > 0;

        if (shouldShow && this.approvalConfig.Period) {
            markSelector.push(getSelector("StartIst"));
            markSelector.push(getSelector("EndeIst"));
            markSelector.push(getSelector("Arbeitsbeginn"));
            markSelector.push(getSelector("Arbeitsende"));
        } else {
            resetSelector.push(getSelector("StartIst"));
            resetSelector.push(getSelector("EndeIst"));
            resetSelector.push(getSelector("Arbeitsbeginn"));
            resetSelector.push(getSelector("Arbeitsende"));
        }

        if (shouldShow && this.approvalConfig.Resource) {
            markSelector.push(getSelector("RessNr"));
        } else {
            resetSelector.push(getSelector("RessNr"));
        }

        if (shouldShow && this.approvalConfig.Texts) {
            markSelector.push(getSelector("Taetigkeit"));
            markSelector.push(getSelector("Bemerkung"));
        } else {
            resetSelector.push(getSelector("Taetigkeit"));
            resetSelector.push(getSelector("Bemerkung"));
        }

        if (this.approvalEnabled && this.props.entity.Approvals < this.approvalConfig.Level) {
            markSelector.push(getSelector("Approvals"));
        } else {
            resetSelector.push(getSelector("Approvals"));
        }

        if (resetSelector.length > 0) {
            $(resetSelector.join(", ")).css("color", "");
        }
        if (markSelector.length > 0) {
            $(markSelector.join(", ")).css("color", "red");
        }
    }

    private resetApproval = (successCallback?: () => void) => {
        if (!this.props.entity.IsNew) {
            HTTPService.get<JsonResultClass>("ResourcePlanning/SetApproval?level=0&projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + this.props.entity.PIndex)
                .then(result => {
                    if (result.Code > 0) {
                        NotificationHelper.showErrorMessage(result.Message);
                    } else {
                        NotificationHelper.showSuccessMessage(result.Message);
                        this.props.entity.Approvals = 0;
                        this.props.entity.Statussend = null;
                        this.approvalResetNeeded = false;

                        this.setState({}, successCallback);
                    }
                });
        } else {
            if (this.defined(successCallback)) {
                successCallback();
            }
        }
    }

    private resetApprovalRequired = (): boolean => {
        return this.approvalResetNeeded ||
            (this.approvalResetNeededFromCode && this.approvalConfig.Level > 0 && this.defined(this.props.entity.Approvals) && this.props.entity.Approvals > 0);
    }

    private openProjectEditWindow = (isNewMode: boolean) => {
        let projectCreated = false;
        const url = isNewMode ? 'Project/New?isWindow=true' : ('Project/Edit?isWindow=true&id=' + encodeURIComponent(this.props.entity.ProjNr));
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        General.Functions.HistoryState.pushSheetState(sheet, url);

        sheet.setTitle(this.translations["Projekt.Projektplanung"]);
        if (isNewMode) {
            sheet.bind(SheetEventType.Close, () => {
                if (!projectCreated) {
                    this.props.entity.KennungTypeWithKey = this.internalData.previousCode;
                }
            });
            sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
                projectCreated = true;
                this.handleIsSearchFieldFullObjectModel({ model: "entity.ProjNr" }, data.entity);
            });
        } else {
            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                this.getApprovalConfig(this.props.entity.ProjNr, this.props.entity.KennungObj.KNr);
            });
        }
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "reportAcquisitionChanged") {
                this.props.entity.ReportAcquisition = cus.value;
                this.setState({});
            }
        });
    }

    private resetProperty = (name: string, force = false) => {
        if (this.props.entity.IsNew === true || force) {
            this.props.entity[name] = null;
        }
    }

    private updateCodeDdl = (ds: any) => {
        if (ds) {
            this.assignmentCodesDS.length = 0;
            for (let i = 0; i < ds.length; i++) {
                this.assignmentCodesDS.push(ds[i]);
            }
            this.common.commandManager.runCommand("entity.KennungTypeWithKey", Commands.RELOADDATASOURCE);
            this.setState({});
        }
    }

    private getAssignmentCodes = async () => {
        let url = this.props.entity.IsNew === true ? 'ResourcePlanningLookup/GetKennungenForEdit' : 'ResourcePlanningLookup/GetKennungenForChange?typ=' + this.props.entity.KennungTyp;
        try {
            let result = await HTTPService.get(url)
            this.updateCodeDdl(result);
        }
        catch {
            if (Array.isArray(this.assignmentCodesDS)) {
                this.assignmentCodesDS.length = 0;
            }
        }
    }

    private releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.IsId, "PLANUNG");
            this.lockId = undefined;
        }
    }

    private setListBoxRef = (r: ListBox) => {
        this.listboxRef = r;
    }

    private openDialog = () => {
        this.setState({
            showDialog: true,
        });
    }

    private dialog = () => {
        this.setState({
            showDialog: false
        });
    }

    private fragmentCopyAssignment(copyToContainer: boolean) {
        const items = this.listboxRef.getItems();
        const itemsRight = items.right;
        let arrProjnr = [];
        let arrPindex = [];
        for (let i = 0; i < itemsRight.length; i++) {
            arrProjnr.push(itemsRight[i].ProjNr);
            arrPindex.push(itemsRight[i].Pindex);
        }
        HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/FragmentationCopyAssignment",
            {
                projnr: arrProjnr,
                pindex: arrPindex,
                startIstFehl: this.props.entity.StartIst,
                endeIstFehl: this.props.entity.EndeIst, copyToContainer: copyToContainer
            })
            .then(result => {
                if (result.Code === 1) {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                else if (result.Code === 2) {
                    NotificationHelper.showWarningMessage(result.Message);
                }
                else {
                    NotificationHelper.showSuccessMessage(result.Message);
                }
                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", doFullRefresh: true });

            });

        this.dialog();
    }

    private getDialogeActions = (): Array<DialogAction> => {
        return [
            {
                label: Config.translations.ignore,
                action: () => {
                    this.dialog();
                }
            },
            {
                label: this.translations["Einsatz.SplitUp"],
                action: () => {
                    this.fragmentCopyAssignment(false);

                }
            },
            {
                label: this.translations["Einsatz.SplitUpAndCopy"],
                action: () => {
                    this.fragmentCopyAssignment(true);
                }
            },
            {
                label: Config.translations.apply,
                action: () => {
                    const items = this.listboxRef.getItems();
                    const itemsRight = items.right;
                    const moveInstances: Array<HTTPRequestConfig> = [];
                    for (let i = 0; i < itemsRight.length; i++) {
                        moveInstances.push({
                            url: "ResourcePlanningScheduler/MoveAssignment",
                            type: HTTPRequestType.Post,
                            data: {
                                projNr: itemsRight[i].ProjNr,
                                pIndex: itemsRight[i].Pindex,
                                settings: null,
                                newStart: itemsRight[i].StartIst,
                                newEnd: itemsRight[i].EndeIst,
                                newResourceId: "g|" + itemsRight[i].GrNr,
                                oldResourceId: "r|" + itemsRight[i].RessNr,
                                resizeAction: false,
                                slot: null,
                                byDelta: false
                            }
                        });
                    }

                    debugger;
                    if (moveInstances.length > 1) {
                        HTTPService.batch(...moveInstances).then((result) => {
                            let error = false;
                            for (let j = 0; j < result.length; j++) {
                                if (result[j].Code > 0) {
                                    error = true;
                                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlanning.ProjektNichtVerschoben"] + " " + itemsRight[j].ProjNr + "/" + String(itemsRight[j].Pindex));
                                }
                            }
                            if (!error && (result.length > 0)) {
                                NotificationHelper.showSuccessMessage(result[0].Message);
                            }
                            this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", doFullRefresh: true });
                        });
                    } else if (moveInstances.length > 0) {
                        HTTPService.post<JsonResultClass>(moveInstances[0].url, moveInstances[0].data)
                            .then(result => {
                                if (result.Code > 0) {
                                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlanning.ProjektNichtVerschoben"] + " " + itemsRight[0].ProjNr + "/" + String(itemsRight[0].Pindex));
                                } else {
                                    NotificationHelper.showSuccessMessage(result.Message);
                                }
                                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", doFullRefresh: true });
                            });
                    }
                    this.dialog();
                },
                primary: true

            }];
    }

    public async asyncGroupDialog(projNr: string, pIndex: number, grouping: number,
        newStart: string, newEnd: string, oldRessId: string, newRessId: string): Promise<boolean> {

        const dp = {
            resizeAction: true,
            projNr: projNr,
            pIndex: pIndex,
            groupings: [grouping],
            mainAssignmentLockId: null,
            settings: null,
            onGetDataBack: (data: any) => {
                this.setState({ movedGroupingArray: data })
            },
            oldRess: oldRessId,
            newRess: newRessId,
            newStart: newStart,
            newEnd: newEnd,
            assignmentsNoGrouping: []
        } as ResourcePlanningGroupingDialogProps;

        const myModal = ModalHelper.createModal<ResourcePlanningGroupingDialogProps>(ResourcePlanningGroupingDialog);
        return myModal(dp);
    }


    private executeSave = async (closeAfterSave: boolean = false, showMessage: boolean = true, reloadSheet: boolean = false) => {
        let canSave = true;
        let checkSla: boolean;

        const listProject = [];
        if ((!this.props.entity.IsNew && (this.props.entity.KennungTyp === 4 || this.props.entity.KennungTyp === 5 || this.props.entity.KennungTyp === 6) && !this.props.entity.IsContainerEinsatz)) {
            canSave = await ResourcePlanningHelper.checkSkills(this.props.entity.ProjNr, this.props.entity.PIndex, this.props.entity.RessNr, Helper.getTranslation("WebSMS.ResourcePlanning.CheckSkillsNegative"));
        }


        const doSave = async (showMessage: boolean): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {

                const checkSave = await HTTPService.post<JsonResultClass>("ResourcePlanning/SaveAssignment", this.props.entity)

                const saveId = this.props.entity.IsId;

                if (checkSave.Code === 0) {
                    this.disableSendState = false;
                    Helper.saveDataToStorage("maxEndDate", checkSave.Data.Arbeitsende, false);
                    listProject.push(checkSave.Data.ProjNr);
                    listProject.push(checkSave.Data.PIndex);

                    if (this.props.entity.IsNew) {
                        const ressId = "&resourceId=" + ((checkSave.Data.RessNr != null) ? ("r|" + checkSave.Data.RessNr) : ("g|" + checkSave.Data.GrNr));
                        General.Functions.HistoryState.replaceState("ResourcePlanning/Edit?projnr=" + checkSave.Data.ProjNr + "&pindex=" + checkSave.Data.PIndex + ressId);
                    }

                    let indivData = checkSave.Data.IndividualFields
                    Helper.updateEntity(this.props.entity, checkSave.Data);
                    this.refreshDeleteEnabled();
                    for (let key in indivData) {
                        this.props.entity.IndividualFields[key] = indivData[key];
                    }

                    if (this.defined(saveId))
                        this.props.entity.IsId = saveId;

                    if (this.defined(this.props.entity.IsId) && this.lockId === undefined) {
                        this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "PLANUNG", 10000);
                    }


                    this.props.entity.IsNew = false;

                    $(window).trigger("saveAssignmentSkills");

                    this.internalData.existingProjectTriggered = false;

                    //if (!closeAfterSave) {
                    await this.getAssignmentCodes();
                    this.getApprovalConfig(this.props.entity.ProjNr, this.props.entity.KennungObj.KNr);
                    /*}
                    else {
                        this.releaseLock();
                    }*/

                    $(window).trigger("saveSkills", this.props.entity);

                    if (showMessage) {
                        NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
                        this.common.handlePostSave(true, closeAfterSave);
                    }
                    let copiedEntity = JSON.parse(JSON.stringify(this.props.entity));
                    copiedEntity.IsSaved = true;
                    Helper.updateEntity(this.props.entity, copiedEntity);
                    this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", projnr: checkSave.Data.ProjNr, pindex: checkSave.Data.PIndex, doFullRefresh: false });
                    this.setState({ skillsChanged: false });
                    resolve(true);

                } else {
                    NotificationHelper.showErrorMessage(checkSave.Message);

                    resolve(false);
                }
            });
        }


        const checkOverlapped = async () => {
            const result = await HTTPService.post<JsonResultClass>("ResourcePlanning/CheckOverlapPresenceTime", this.props.entity)
            if (Config.user.splitUpAndCutAssignment && result.Code === 0 && result.Data.assignmetsToSplit != null && result.Data.assignmetsToSplit.length > 0) {
                if (result.Data.assignmentsWithFixStartOrEnd != null && result.Data.assignmentsWithFixStartOrEnd.length > 0)
                    NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.FixierterEinsatzCanNotSplit"));
                this.listRemoveItems = result.Data.assignmetsToSplit;
                this.listTotalItems = result.Data.assignmetsToSplit;
                this.listNotRemoveItems = [];
                this.openDialog();
                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", projnr: result.Data.ProjNr, pindex: result.Data.PIndex, doFullRefresh: true });
            }
            return result;
        }

        const acceptMoveEx = async (data: any[], showMessage: boolean): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {
                const result = await HTTPService.post<JsonResultClass>(
                    "ResourcePlanningScheduler/MoveAssignmentEx",
                    { settings: null, moveAssigmentInfoEx: data })

                if (result.Code == 0) {

                    result.Data.forEach((e: any) => {
                        this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", projnr: e.projNr, pindex: e.pIndex, doFullRefresh: false });
                    })

                    if (showMessage)
                        NotificationHelper.showSuccessMessage(result.Message);


                    resolve(true);
                }
                else {

                    //   if (showMessage)
                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlaningGrouping.GruppeNichtVerschoben"] + ' ' + result.Message);

                    resolve(false);
                }
            });
        }

        checkSla = await ResourcePlanningHelper.checkSla(kendo.parseDate(this.props.entity.Arbeitsbeginn), this.props.entity.ProjNr, this.props.entity.PIndex, this.props.entity.Ticket);

        if (canSave && checkSla) {
            //1. Save mit rollback

            let checkSave = this.assignmentGroupingActive ?
                await HTTPService.post<JsonResultClass>("ResourcePlanning/SaveAssignmentCheck", {
                    model: this.props.entity,
                    doLock: false
                }) : null;

            if (this.state.skillsChanged && Helper.hasValue(this.props.entity.RessNr)) {
                let shouldSave = await ResourcePlanningHelper.checkSkillsAssignment(this.props.entity.RessNr, this.state.currentSkills);
                if (!shouldSave)
                    return;
            }

            if (checkSave == null || checkSave.Code === 0) {

                const changed = checkSave != null &&
                    (this.oldStart != this.props.entity.StartIst || this.oldEnd != this.props.entity.EndeIst);

                const newResourceId = Helper.hasValue(this.props.entity.RessNr) ? "r|" + this.props.entity.RessNr : "g|" + this.props.entity.GrNr;
                if (newResourceId != this.oldResourceId) {
                    let shouldSave = await OpenResourcePlanningMovingDialog(this.props.entity, Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ReallyMove"));
                    if (!shouldSave)
                        return;
                }

                if (checkSave != null && (changed || newResourceId != this.oldResourceId)) {
                    if (await this.asyncGroupDialog(checkSave.Data.ProjNr, checkSave.Data.PIndex,
                        checkSave.Data.Gruppierung,
                        this.props.entity.StartIst, this.props.entity.EndeIst,
                        this.oldResourceId, newResourceId)) {
                        this.oldStart = this.props.entity.StartIst;
                        this.oldEnd = this.props.entity.EndeIst;
                        this.oldResourceId = newResourceId;
                        const hasData = (this.state.movedGroupingArray != null && this.state.movedGroupingArray.length > 0);

                        if (await doSave(!hasData)) {
                            if (hasData) {
                                await acceptMoveEx(this.state.movedGroupingArray, true);
                            }
                            else {
                                checkSave = await checkOverlapped();
                            }
                        }
                        this.common.handlePostSave(checkSave.Code === 0, closeAfterSave);
                    } else {
                        this.common.setEntityDirtyState(true);
                        return;
                    }
                }
                else {
                    if (await doSave(showMessage)) {
                        const result = await checkOverlapped();
                        this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    }
                }

                if (reloadSheet) {
                    this.reloadSheetAfterRebook();
                }
            }
            else {
                NotificationHelper.showErrorMessage(checkSave.Message);
            }

            this.setPmShow();

        } else { //if (canSave && checkSla)
            this.common.setEntityDirtyState(true);
        }
    }

    private calculateTravelTimes = async () => {
        if (Helper.hasValue(this.props.entity.Arbeitsbeginn) && Helper.hasValue(this.props.entity.Arbeitsende)) {
            let result = await HTTPService.post<JsonResultClass>("Directions/CalculateTravelTimes", { projNr: this.props.entity.ProjNr, pIndex: this.props.entity.PIndex, forceCheckLock: false })

            if (result.Code > 0) {
                NotificationHelper.showErrorMessage(result.Message);
            } else {
                const journey = result.Data as AssignmentTraveldataModel[];

                await this.handleFieldChange({ model: "entity.StartIst" }, journey[0].assignmentTimes.startIst);
                await this.handleFieldChange({ model: "entity.EndeIst" }, journey[0].assignmentTimes.endeIst);

                for (let i = 0; i <= journey.length - 1; i++) {
                    this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", projnr: journey[i].projNr, pindex: journey[i].pIndex, doFullRefresh: false });
                }

                await this.executeSave(false, false, false);
            }
        }
        else {
            NotificationHelper.showErrorMessage(this.translations["WebSMS.Messages.PleaseEnterValidDateTimes"]);
        }
    }

    private afterConvertedTimesClose = () => {
        if (this.state.showConvertedTimesDialog) {
            this.setState({ showConvertedTimesDialog: false });
        }
    }

    // noinspection JSUnusedGlobalSymbols
    renderApproval = () => {
        if (!Config.settings.approvalProcessActive)
            return null;
        let currentApprovalLevel = this.defined(this.props.entity.Approvals) && this.props.entity.Approvals >= 0 ? this.props.entity.Approvals : 0;
        if (this.approvalConfig.Level < currentApprovalLevel) {
            currentApprovalLevel = this.approvalConfig.Level;
        }

        return (
            <div style={{ display: "flex", alignItems: "center" }}>
                <div>{currentApprovalLevel}/{this.approvalConfig.Level}</div>
                <div className={"innoOptionsButton innoOptionsPerformAction" + (this.props.configData.approvalLevel > this.props.entity.Approvals ? "" : " innoDisabled")}
                    style={{ marginLeft: "15px" }} onClick={this.addApproval} >
                    {(this.props.entity.RecordRight.CanWrite && this.approvalEnabled && this.props.configData.approvalLevel > this.props.entity.Approvals) ? <FAIcon name="fal fa-plus" style={{ cursor: "pointer" }} /> : null}
                </div>
            </div>
        );
    }

    handleFieldChange = async (field: { model: string }, value: any, dataItem: any = null, isInit = false) => {
        let resetChange = false;
        let resetValue = null;
        let resetProp = null;
        let og_value = null;
        let [updatedValue, isOK] = [value, undefined];
        switch (field.model) {

            case "entity.KennungTypeWithKey":
                this.internalData.previousCode = this.props.entity.KennungTypeWithKey;//oldValue;
                let knr = null;
                if (value && value !== "1_1")
                    this.props.entity.HalberTag = false;

                if (value && value.indexOf("_") >= 0) {
                    const parts = value.split("_");
                    knr = parts[1];
                    if (this.props.entity.IsNew) {
                        if (parts[0] === "00") {
                            this.projectSearchEnabled = false;
                            this.addressSearchEnabled = false;
                            this.resetProperty("AdrNr");
                            this.internalData.projectRequired = true;
                            this.internalData.addressRequired = false;
                            this.openProjectEditWindow(true);
                        } else if (parts[0] === "0" || parts[0] === "4" || parts[0] === "5") {
                            this.projectSearchEnabled = true;
                            this.addressSearchEnabled = false;
                            if (this.props.entity.ProjNr === "9999999" || this.props.entity.ProjNr === "0000000") {
                                this.resetProperty("ProjNr");
                            }
                            if (!isInit)
                                this.resetProperty("AdrNr");
                            this.internalData.projectRequired = true;
                            this.internalData.addressRequired = false;
                            this.internalData.existingProjectTriggered = true;
                        } else if (parts[0] === "3") {
                            this.projectSearchEnabled = false;
                            this.addressSearchEnabled = true;
                            this.props.entity.ProjNr = "9999999";
                            this.internalData.projectRequired = false;
                            this.internalData.addressRequired = true;
                            if (!isInit) {
                                let daResult = await HTTPService.get("ResourcePlanningLookup/GetDefaultAddressForCode?knr=" + parts[1]);
                                if (daResult && daResult.adrnr && !this.props.entity.AdrNr) {
                                    this.common.handleFieldChange({ model: "entity.AdrNr" }, daResult.adrnr);
                                } else {
                                    this.common.handleFieldChange({ model: "entity.AdrNr" }, this.props.entity.AdrNr);
                                }
                            }

                        } else if (parts[0] === "6") {
                            this.internalData.projectRequired = false;
                            this.internalData.addressRequired = false;
                            MetaDataHelper.setRequired(this.props.metadata, "entity.ProjNr", this.internalData.projectRequired);
                        }
                        else {
                            this.projectSearchEnabled = false;
                            this.addressSearchEnabled = false;
                            this.resetProperty("AdrNr");
                            if (parts[0] === "1") {
                                if (this.props.entity.HalberTag === true) {
                                    this.props.entity.Arbeitszeit = this.props.configData.workHours / 2;
                                } else {
                                    this.props.entity.Arbeitszeit = this.props.configData.workHours;
                                }
                                this.props.entity.ProjNr = "0000000";
                                this.internalData.projectRequired = false;
                                this.internalData.addressRequired = false;
                            } else if (parts[0] === "2") {
                                this.props.entity.ProjNr = "0000000";
                                this.internalData.projectRequired = false;
                                this.internalData.addressRequired = false;
                            }
                        }

                        //set other code properties
                        for (let i = 0; i < this.assignmentCodesDS.length; i++) {
                            if (this.assignmentCodesDS[i].Value === value) {
                                this.props.entity.Kennung = this.assignmentCodesDS[i].Name2;
                                break;
                            }
                        }
                    }

                    MetaDataHelper.setVisibility(this.props.metadata, "entity.HalberTag", parts[0] === "1");
                } else {
                    //don't resent on initial load
                    if (value !== this.props.entity.KennungTypeWithKey) {
                        this.projectSearchEnabled = false;
                        this.addressSearchEnabled = false;
                        this.resetProperty("AdrNr");
                        this.resetProperty("ProjNr");
                        MetaDataHelper.setVisibility(this.props.metadata, "entity.HalberTag", false);
                    }
                }
                MetaDataHelper.setRequired(this.props.metadata, "entity.AdrNr", this.internalData.addressRequired);
                MetaDataHelper.setRequired(this.props.metadata, "entity.ProjNr", this.internalData.projectRequired);
                if (!isInit) {
                    this.common.validatorHelper.hideMessages();
                    const prevApprovalLevel = this.approvalConfig.Level;
                    this.getApprovalConfig(this.props.entity.ProjNr, knr, () => {
                        this.approvalResetNeededFromCode = this.approvalConfig.Level > prevApprovalLevel;
                    });
                }

                break;
            case "entity.HalberTag":
                if (value === true) {
                    this.props.entity.Arbeitszeit = this.props.configData.workHours / 2;
                } else {
                    this.props.entity.Arbeitszeit = this.props.configData.workHours;
                }
                break;
            case "entity.Arbeitszeit":
                if (this.defined(value)) {
                    this.props.entity.PercentageWorkDisplay = " " + (value * 100 / this.props.configData.workHours).toFixed(2) + " %";
                    this.props.entity.PercentageWork = (value * 100 / this.props.configData.workHours);
                }
                break;
            case "entity.DauerInMonaten":
                if (typeof value === 'number' && value !== this.props.entity.DauerInMonaten) {
                    let startIst = kendo.parseDate(this.props.entity.StartIst);
                    let endeIst = kendo.parseDate(this.props.entity.EndeIst);
                    let endDate = new Date(startIst.getTime());
                    endDate.setMonth(endDate.getMonth() + value);
                    if (value > 0) {
                        endDate.setDate(endDate.getDate() - 1);
                    }

                    // Uhrzeit von EndeIst stehenlassen 
                    if (this.props.entity.EndeIst !== null) {
                        endDate.setHours(endeIst.getHours());
                        endDate.setMinutes(endeIst.getMinutes());
                        endDate.setSeconds(endeIst.getSeconds());
                    }

                    this.props.entity.EndeIst = Helper.dates.getISODateString(endDate);
                }
                break;
            case "entity.StartIst":
                this.handleApprovalFieldChange(ApprovalFields.PeriodStart);
                og_value = JSON.parse(JSON.stringify(this.props.entity.StartIst));
                [updatedValue, isOK] = this.checkWorkBeginAndEnd("Begin", value);
                if (!isInit && isOK) {
                    isOK = await this.checkForMultipleOccupancies(updatedValue as string, this.props.entity.EndeIst);
                    if (!isOK) {
                        updatedValue = og_value;
                    }
                }
                value = updatedValue;
                break;
            case "entity.EndeIst":

                this.handleApprovalFieldChange(ApprovalFields.PeriodEnd);
                if (this.defined(value)) {
                    this.props.entity.DauerInMonaten = 0;
                }
                og_value = JSON.parse(JSON.stringify(this.props.entity.EndeIst));
                [updatedValue, isOK] = this.checkWorkBeginAndEnd("End", value);
                if (!isInit && isOK) {
                    isOK = await this.checkForMultipleOccupancies(this.props.entity.StartIst, updatedValue as string);
                    if (!isOK) {
                        updatedValue = og_value;
                    }
                }
                value = updatedValue;
                break;
            case "entity.IsContainerEinsatz":
                if (value) {
                    this.props.entity.RessNr = null;
                    this.props.entity.RessourceFixiert = false;
                    if (!isInit) {
                        await this.reloadWorkingTime(null);
                        if (this.props.entity.GrNr)
                            await this.reloadHourlyRate(null, this.props.entity.GrNr);
                    }
                } else if (!value) {
                    this.resetProperty("GrNr");
                    if (!isInit && this.props.entity.RessNr)
                        await this.reloadHourlyRate(this.props.entity.RessNr, null);
                }
                break;
            case "entity.PIndexView":
                if (this.defined(value) && this.props.configData.pmLink && this.defined(dataItem)) {
                    if (this.props.configData.pmLink - 1 > dataItem.Lev) {
                        value = null;
                    }
                }
                this.showAlternateCommentField = !Helper.hasValue(value) || Helper.isNullOrEmpty((value as string));
                break;
            case "entity.ProjNr":
            case "entity.KennungTyp":
                if (Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(dataItem.ProjNr)) {
                    value = dataItem.ProjNr;
                }
                if (field.model === "entity.ProjNr") {
                    if (!isInit) {
                        await this.loadMaingroupByProjNr(value);
                        let knr = null;
                        if (this.defined(this.props.entity.KennungTypeWithKey) && this.props.entity.KennungTypeWithKey.indexOf("00") !== 0) {
                            knr = this.props.entity.KennungTypeWithKey.split("_")[1];
                        }
                        if (this.props.entity.KennungTypeWithKey === "0_" && Helper.isNullOrEmpty(this.props.entity.AdrNr)) {
                            isInit = true;
                            await this.setValuesFromProjectRequestSavely(dataItem.ProjNr, dataItem.AdrNr, dataItem.ProjNr2, dataItem.KNr, dataItem.Kennung, dataItem.AuStatus)
                            this.setState({});
                        } else if (Helper.hasValue(dataItem) && this.props.entity.AdrNr !== dataItem.AdrNr) {
                            await this.setValuesFromProjectRequestSavely(dataItem.ProjNr, dataItem.AdrNr, dataItem.ProjNr2, null, null, dataItem.AuStatus);
                        } else if (Helper.isNullOrEmpty(value)) {
                            await this.handleFieldChange({ model: "entity.AdrNr" }, null);
                        }
                        this.resetApproval(() => {
                            this.getApprovalConfig(value, knr);
                        });
                    }
                }
                break;
            case "entity.Statussend":
                if (this.defined(value) && value > 0 && this.approvalConfig.Level > 0 && this.props.entity.Approvals < this.approvalConfig.Level) {
                    NotificationHelper.showWarningMessage(this.translations["WebSMS.ResourcePlanning.CannotSaveApprovalRequired"]);
                    resetChange = true;
                    resetValue = this.props.entity.Statussend;
                    resetProp = "Statussend";
                }
                break;
            case "entity.RessNr":
                this.handleApprovalFieldChange(ApprovalFields.Resource);
                await this.reloadWorkingTime(value ?? "");
                if (!this.props.entity.IsContainerEinsatz)
                    await this.reloadHourlyRate(value ?? 0, this.props.entity.GrNr);
                break;
            case "entity.GrNr":
                await this.reloadHourlyRate(null, value);
                break;
            case "entity.AdrNr":
                await this.reloadExpenses(value);
                break;
            case "entity.Taetigkeit":
                this.handleApprovalFieldChange(ApprovalFields.TextActivity);
                break;
            case "entity.Bemerkung":
                this.handleApprovalFieldChange(ApprovalFields.TextRemark);
                break;
            case "entity.Arbeitsbeginn":

                const reset = () => {
                    value = this.props.entity.Arbeitsbeginn;
                }

                const editMode = !Config.user.autoCalcTravelStart && this.props.entity.KennungTyp > 2 ? await this.autoCalcTravelStart() : StartEditingStuff.TravelAndWorkStart;

                switch (editMode) {
                    case StartEditingStuff.TravelAndWorkStart:
                        const isOk = await this.followWorkBeginAndEnd("Begin", this.props.entity.Arbeitsbeginn, value);
                        if (!isInit && isOk) {
                            this.calculateIsMultipleDaysAssignment(value, this.props.entity.Arbeitsende);
                            this.handleApprovalFieldChange(ApprovalFields.PeriodStart);
                        } else {
                            reset()
                        }
                        break;
                    case StartEditingStuff.OnlyWorkStart:
                        if (!isInit) {
                            this.calculateIsMultipleDaysAssignment(value, this.props.entity.Arbeitsende);
                            this.handleApprovalFieldChange(ApprovalFields.PeriodStart);
                        } else {
                            reset()
                        }
                        break;
                    case StartEditingStuff.None:
                        reset();
                        break;
                }
                break;
            case "entity.Arbeitsende":
                const c2 = await this.followWorkBeginAndEnd("End", this.props.entity.Arbeitsende, value);
                if (!isInit && c2) {
                    this.calculateIsMultipleDaysAssignment(this.props.entity.Arbeitsbeginn, value);
                    this.handleApprovalFieldChange(ApprovalFields.PeriodEnd);
                } else {
                    value = this.props.entity.Arbeitsende;
                }
                break;
            case "entity.Gruppierung":
                if (Helper.hasValue(value) && value != "") {
                    let x = parseInt(value, 10);
                    if (!Helper.hasValue(x)) {
                        value = 0;
                    } else {
                        value = x;
                    }
                }
                else {
                    value = 0;
                }
                this.props.entity.Gruppierung = value;

                break;
            case "entity.PlanningBoardFlagId":
                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "reloadFlags" });
                break;
            case "entity.FirstAssignment":
                this.props.entity.ContinuationJourney = 0;
                break;
            case "entity.ContinuationJourney":
                this.props.entity.FirstAssignment = 0;
                break;
            default:
                break;
        }

        const entityChanged = this.common.entityChanged;
        if (resetChange) {
            value = resetValue;
        }

        if (!isInit) {
            this.setPmShow();
            this.common.handleFieldChange(field, value, dataItem, () => {
                if (resetChange) {
                    if (resetProp === "Statussend") {
                        this.common.commandManager.runCommand("entity.Statussend", Commands.RELOADVALUE);
                    }
                    this.common.setEntityDirtyState(entityChanged);
                }
                this.updateResourceSearchURL();
            });
        }
    }

    private checkForMultipleOccupancies = async (start: Date | string, end: Date | string) => {
        const projNr = this.props.entity.ProjNr;
        const pIndex = this.props.entity.PIndex;
        const resource = this.props.entity.IsContainerEinsatz ? `g|${this.props.entity.GrNr}` : `r|${this.props.entity.RessNr}`;

        return await Util.CheckForMultipleOccupancies(projNr, pIndex, start, end, resource);

    }

    private reloadWorkingTime = async (ressnr: string, initial: boolean = true) => {
        if (this.props.entity.IsNew || !initial) {
            HTTPService.get("ResourcePlanningLookup/GetWorkingHours?ressNr=" + (ressnr ?? ""))
                .then(async result => {
                    this.props.configData.workHours = result;
                    await this.handleFieldChange({ model: "entity.Arbeitszeit" }, result);
                    await this.handleFieldChange({ model: "entity.HalberTag" }, this.props.entity.HalberTag);
                });
        }
    }

    private reloadHourlyRate = async (ressNr: string, grNr: number) => {
        let result = await HTTPService.get<JsonResultClass>("ResourcePlanningLookUp/GetCosts?"
            + "projNr=" + encodeURIComponent(this.props.entity.ProjNr)
            + "&pIndex=" + encodeURIComponent(this.props.entity.PIndex)
            + "&ressNr=" + encodeURIComponent(ressNr ?? "")
            + "&grNr=" + encodeURIComponent(grNr));

        if (result.Code == 0)
            await this.handleFieldChange({ model: "entity.Stundensatz" }, result.Data.HourlyRate);

        return result;
    }

    private reloadExpenses = async (adrNr: string) => {
        let result = await HTTPService.get<JsonResultClass>("ResourcePlanningLookUp/GetCosts?"
            + "projNr=" + encodeURIComponent(this.props.entity.ProjNr)
            + "&pIndex=" + encodeURIComponent(this.props.entity.PIndex)
            + "&adrNr=" + encodeURIComponent(adrNr));

        if (result.Code == 0) {
            await this.handleFieldChange({ model: "entity.Spesen" }, result.Data.Expenses);
            await this.handleFieldChange({ model: "entity.Uebernachtung" }, result.Data.Overnight);
        }

        return result;
    }

    private checkWorkBeginAndEnd = (kind: "Begin" | "End", value: string) => {
        let isOk = true;
        let result = value;

        if (kind === "Begin") {
            let workStart = Helper.dates.toDate(this.props.entity.Arbeitsbeginn);
            if (workStart < Helper.dates.toDate(value)) {
                result = this.props.entity.Arbeitsbeginn;
                NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.AnfahrtNichtImZeitraum"));
                isOk = false;
            }
        } else if (kind === "End") {
            let workEnd = Helper.dates.toDate(this.props.entity.Arbeitsende);
            if (workEnd > Helper.dates.toDate(value)) {
                result = this.props.entity.Arbeitsende;
                NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.ArbeitsendeNichtImZeitraum"));
                isOk = false;
            }
        }
        return [result, isOk];
    }

    private followWorkBeginAndEnd = async (kind: "Begin" | "End", oldDate: string, newDate: string) => {
        let isOk = true;
        if (newDate !== null && isOk) {

            let oDate = Helper.dates.toDate(oldDate);
            let nDate = Helper.dates.toDate(newDate);
            let startEndeIstIsVisible = this.props.entity.KennungTyp > 2;
            if (kind === "Begin") {
                let startOfWork = Helper.dates.toDate(this.props.entity.StartIst);
                const startIst = Helper.dates.getISODateString(this.calculateStartTime(oDate, nDate, startOfWork));
                const isOk = await this.checkForMultipleOccupancies(startIst, this.props.entity.EndeIst);
                if (!isOk) {
                    return false;
                }
                this.props.entity.StartIst = startIst;
                if (startEndeIstIsVisible)
                    NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.CorrectStartJourney"));
                this.setState({});
            } else if (kind === "End") {
                let endOfWork = Helper.dates.toDate(this.props.entity.EndeIst);
                const endeIst = Helper.dates.getISODateString(this.calculateEndTime(oDate, nDate, endOfWork));
                const isOk = await this.checkForMultipleOccupancies(this.props.entity.StartIst, endeIst);
                if (!isOk) {
                    return false;
                }
                this.props.entity.EndeIst = endeIst;
                if (startEndeIstIsVisible)
                    NotificationHelper.showInfoMessage(Helper.getTranslation("Einsatz.CorrectAssignmentEnd"));
                this.setState({});
            }
            return true;
        }
        return false;
    }

    private autoCalcTravelStart = () => {
        return new Promise<StartEditingStuff>((resolve) => {
            const targetElement = $("<div>");
            $("body").append(targetElement);

            const remove_dialog = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            }

            const dialogProps: DialogProps = {
                title: Helper.getTranslation("Einsatz.AdjustTravelStart"),
                actions: [
                    {
                        label: Helper.getTranslation("Standard.Abbrechen"),
                        action: () => {
                            resolve(StartEditingStuff.None)
                        },
                        primary: false
                    },
                    {
                        label: Helper.getTranslation("Server.No"),
                        action: () => {
                            resolve(StartEditingStuff.OnlyWorkStart)
                        },
                        primary: false
                    },
                    {
                        label: Helper.getTranslation("Server.Yes"),
                        action: () => {
                            resolve(StartEditingStuff.TravelAndWorkStart)
                        },
                        primary: true
                    }
                ],
                afterClose: remove_dialog,
                width: 350,
                open: true
            };
            ReactDOM.render(<Dialog {...dialogProps} />, targetElement[0]);
        })
    }

    private calculateStartTime = (oldDate: Date, newDate: Date, startOfWork: Date) => {
        let prevDate = oldDate === null ? startOfWork : oldDate;
        let difference = prevDate.getTime() - startOfWork.getTime();
        return new Date(newDate.getTime() - difference);
    }

    private calculateEndTime = (oldDate: Date, newDate: Date, endOfWork: Date) => {
        let prevDate = oldDate === null ? endOfWork : oldDate;
        let difference = endOfWork.getTime() - prevDate.getTime();
        return new Date(newDate.getTime() + difference);

    }

    private rebookDialogActions: Array<DialogAction> = [
        {
            label: Config.translations.cancel,
            action: () => {
                this.setState({ ...this.state, rebook: { projNr: "", newKNr: null, showDialog: false } });
            }
        },
        {
            label: Config.translations.ok,
            action: () => {
                if (this.state.rebook.projNr !== "") {
                    if ((this.props.entity.KennungTyp !== 4) || Helper.hasValue(this.state.rebook.newKNr)) {
                        const data = { OldAssigment: this.props.entity, NewProjNr: this.state.rebook.projNr, NewKNr: this.state.rebook.newKNr };

                        HTTPService.post<JsonResultClass<ResourcePlanningEntity>>("ResourcePlanning/RebookAssigment", data)
                            .then(result => {
                                if (result.Code === 0) {
                                    this.props.entity.IsNew = false;
                                    this.props.entity.ProjNr = result.Data.ProjNr;
                                    this.props.entity.PIndex = result.Data.PIndex;
                                    this.props.entity.Kennung = result.Data.Kennung;
                                    this.props.entity.KennungTyp = result.Data.KennungTyp;
                                    this.props.entity.KennungTypeWithKey = result.Data.KennungTypeWithKey;
                                    this.props.entity.Kopplung = result.Data.Kopplung;
                                    this.props.entity.PIndexView = result.Data.PIndexView;
                                    this.props.entity.Auftragsnummer = result.Data.Auftragsnummer;
                                    this.props.entity.AdrNr = result.Data.AdrNr;
                                    this.props.entity.Spesen = result.Data.Spesen;
                                    this.props.entity.Uebernachtung = result.Data.Uebernachtung;
                                    this.props.entity.Kennwort = result.Data.Kennwort;
                                    this.props.entity.IndividualFields = result.Data.IndividualFields;
                                    NotificationHelper.showSuccessMessage(result.Message);
                                    this.executeSave(false, false, true).then();

                                } else {
                                    NotificationHelper.showErrorMessage(result.Message);
                                }
                                this.setState({ rebook: { projNr: "", showDialog: false, newKNr: null } });
                            });

                    } else {
                        DialogHelper.alert(this.translations["Standard.PflichtfeldAllgemein"]);
                        return false;
                    }
                }
            },
            primary: true
        }
    ];

    private reloadSheetAfterRebook = () => {
        if (window["dps"] !== undefined) {
            this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "afterRebook", id: this.props.entity.ProjNr + "|" + this.props.entity.PIndex, oldData: this.oldData, oldId: this.oldId });
        } else {

            General.Functions.HistoryState.pushState("ResourcePlanning/Edit?projnr=" + this.props.entity.ProjNr + "&pindex=" + this.props.entity.PIndex);
            window.location.reload();
        }
    }

    private getSearchFieldProps = () => {
        let props = this.factory.getDefaultSearchFieldProps();
        props.onChange = this.handleTextBoxChance;
        props.onOpened = () => {
            Helper.saveDataToStorage("newKNr", this.state.rebook.newKNr, false);
            this.setState({ ...this.state, rebook: { showDialog: false, projNr: "", newKNr: this.state.rebook.newKNr } });
        }
        props.value = this.state.rebook.projNr;
        props.field.searchButtonEnabled = true;
        props.field.searchWindowTitle = "Projekt";
        props.field.readOnlyTextField = false;
        props.field.searchWindowUrl = "DynamicSearch/Project?assignmentgeneration=1";
        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word'>${data.ProjNr}</td><td style='vertical-align:top'>${data.Kennwort}</td><td style='vertical-align:top'>${data.Addresse}</td></tr></table>";
        props.field.autocompleteUrl = "ProjectLookup/Find";
        props.field.autocompleteDataTextField = "ProjNr";
        props.field.listWidth = 700;
        return (props);
    }

    private getDropDownListProps = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.rebook.newKNr;
        props.field.dataSourceUrl = "ResourcePlanningLookup/GetProjectRelatedCodes"
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.onChange = (field: { model: string }, value: any, _dataItem?: any) => {
            let r = this.state.rebook;
            r.newKNr = value;
            this.setState({ rebook: r });

            if (field) {
                //
            }
        }
        props.onDataLoaded = () => { };
        return props;
    }

    private handleTextBoxChance = (field: { model: string }, value: any) => {
        let newKNr = Helper.loadDataFromStorage("newKNr");
        Helper.removeDataFromStorage("newKNr");
        HTTPService.get<JsonResultClass>("ProjectLookup/CheckProjectForRebook?ProjNr=" + value).then(result => {
            if (result.Code === 0) {
                if (result.AdditionalData.AssignmentGeneration) {
                    newKNr = Helper.getValueOrDefault(newKNr, result.AdditionalData.KNr);
                    this.setState({ ...this.state, rebook: { showDialog: true, projNr: value, newKNr: newKNr } });
                } else {
                    DialogHelper.alert(this.translations["WebSMS.GeneralSettings.Project.Status.NoAssignmentGenerationAllowed"]);
                    this.setState({ ...this.state, rebook: { showDialog: true, projNr: "", newKNr: newKNr } });
                }
            }
        });
        this.setState({ ...this.state, rebook: { showDialog: true, projNr: value, newKNr: newKNr } });
        if (field) {
            //
        }
    }

    private checkProjectRelease = () => {
        HTTPService.get<JsonResultClass>("ResourcePlanning/CheckProjectRelease?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + encodeURIComponent(this.props.entity.PIndex))
            .then(result => {
                if (result.Code === 0) {
                    this.props.entity.IsRebookable = result.Data;
                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private boxAssigmentsProps = () => {
        const props = this.factory.getDefaultListBoxProps();
        props.dataSource = this.listTotalItems;
        props.value = this.listRemoveItems;
        props.field.dataTextField = "ProjNr";
        props.field.dataValueField = "Kennung";
        props.field.labelTextLeft = this.translations["WebSMS.ResourcePlanning.NichtVerschiebenEinsatz"];
        props.field.labelTextRight = this.translations["WebSMS.ResourcePlanning.VerschiebenEinsatz"];
        // noinspection JSStringConcatenationToES6Template,CssInvalidHtmlTagReference
        props.field.template = "<style> .listboxProjectElement {border:1px solid black;}<style/><div class=\"listboxProjectElement\"><p>Projektnummer: #=ProjNr# / #=Pindex#</p>  <p> Bemerkung: #=Bemerkung||''#</p> <p>  #=kendo.toString(kendo.parseDate(StartIst), 'g')# - #=kendo.toString(kendo.parseDate(EndeIst), 'g')# </p></div>";
        props.onChange = this.onchangeListBox;
        return props;
    }
    private onchangeListBox = (model: any, value: any, dataItem: any) => {
        let buttons: any;
        // Workaround Updatet sich erst nach den OnChange Event
        let currentItem = this.listTotalItems.filter(x => x.IsGuid === dataItem.IsGuid)[0];
        const selectText = '.k-dialog button.k-button:not(:contains(' + Config.translations.ignore + '))';
        if (this.listboxRef.moveDirectionListBox === 0 && this.listboxRef.moveDirectionListBoxContent !== 1) {
            this.listNotRemoveItems.push(this.listTotalItems.filter(x => x.IsGuid === dataItem.IsGuid)[0]);
            this.listRemoveItems = this.listRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
        } else if (this.listboxRef.moveDirectionListBox === 2 && this.listboxRef.moveDirectionListBoxContent === 2) {
            let index = this.listRemoveItems.indexOf(currentItem) + value;
            this.listRemoveItems = this.listRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
            this.listRemoveItems.splice(index, 0, currentItem);
        }
        else {
            this.listRemoveItems.push(currentItem);
            this.listNotRemoveItems = this.listNotRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
        }
        if (this.listRemoveItems.length === 0) {
            buttons = $(selectText);
            $(buttons).attr('disabled', 'disabled');
        } else {
            buttons = $(selectText);
            $(buttons).removeAttr('disabled');
        }
        if (model) {
            //
        }
    }
    handleIsSearchFieldFullObjectModel = (field: any, object: any) => {
        if (field.model === "entity.ProjNr") {
            if (this.defined(object)) {
                const projNr = Helper.getAttributeSavely(object, "projnr");
                const adrnr = Helper.getAttributeSavely(object, "adrnr");
                const projNr2 = Helper.getAttributeSavely(object, "projnr2");
                const kNr = Helper.getAttributeSavely(object, "knr");
                const kennung = Helper.getAttributeSavely(object, "kennung");

                if (Helper.hasValue(object)) {
                    const austatus = object.austatus === undefined ? object.Status : object.austatus;
                    this.setValuesFromProjectRequestSavely(projNr, adrnr, projNr2, kNr, kennung, austatus).then(() => {
                        this.setState({});
                    });
                }
            }
        }
    }

    private loadMaingroupByProjNr = async (projNr: string) => {
        if (this.props.adjustMaingroupAtNewAssignment && this.props.entity.IsNew && this.props.entity.IsContainerEinsatz) {
            const result = await HTTPService.get<JsonResultClass>(`Project/Get/?id=${projNr}`)
            if (result.Code == 0) {
                await this.handleFieldChange({ model: "entity.OGrNr" }, result.Data.Ogrnr);
            }
        }
    }

    private setValuesFromProjectRequestSavely = async (projNr: string, adrNr: string, projNr2: string, kNr: number, kennung: string, austatus: any) => {
        if (this.props.entity.KennungTypeWithKey.indexOf("00_") === 0) {
            if (Helper.findIndex(this.assignmentCodesDS, "Value", "5_" + kNr) !== -1)
                this.props.entity.KennungTypeWithKey = "5_" + kNr;
            else
                this.props.entity.KennungTypeWithKey = "4_" + kNr;
            this.props.entity.ProjNr2 = projNr2;
        } else if (this.props.entity.KennungTypeWithKey.indexOf("0_") === 0 || this.internalData.existingProjectTriggered) {
            //this.props.entity.ProjNr = object.projnr;
            this.props.entity.Kennung = kennung;
            if (this.props.entity.KennungTypeWithKey.indexOf("0_") === 0) {
                if (Helper.findIndex(this.assignmentCodesDS, "Value", "5_" + kNr) !== -1)
                    this.props.entity.KennungTypeWithKey = "5_" + kNr;
                else
                    this.props.entity.KennungTypeWithKey = "4_" + kNr;
            }
        }
        if (!Helper.isNullOrEmpty(projNr) && !Helper.isNullOrEmpty(adrNr) && Helper.hasValue(austatus)) {
            const result = await HTTPService.get<JsonResultClass>("ProjectLookup/GetProjectStatus?Id=" + austatus);
            if (result.Code === 0) {
                if (result.Data.AssignmentGeneration) {
                    await this.handleFieldChange({ model: "entity.ProjNr" }, projNr);
                    await this.handleFieldChange({ model: "entity.AdrNr" }, adrNr);
                } else {
                    DialogHelper.alert(this.translations["WebSMS.GeneralSettings.Project.Status.NoAssignmentGenerationAllowed"]);
                }
            }
        }

        if (!Helper.isNullOrEmpty(projNr) && Helper.isNullOrEmpty(this.props.entity.RessNr)) {
            const result = await HTTPService.get<JsonResultClass>("ResourcePlanning/DefaultResourceForProject?projNr=" + encodeURI(projNr));
            if (result.Code === 0) {
                await this.handleFieldChange({ model: "entity.RessNr" }, result.Data);
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols
    editProject = () => {
        this.openProjectEditWindow(false);
    }
    // noinspection JSUnusedGlobalSymbols
    executeServerTemplate = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        let url = 'ServerTemplate/InitExecuteTemplate?Ressnr=' + encodeURIComponent(this.props.entity.RessNr) + "&Templateid=1&RessourceTyp=1";
        const results = await Promise.all([
            HTTPService.get(url),
            Helper.getMetaData("serverTemplateExecute")
        ]);
        sheet.show(() => {
            const servertemplateexecutevm = results[0].Data;
            const metadata = results[1];
            const props = {
                title: "",
                entity: servertemplateexecutevm,
                context: { contextType: "serverTemplateExecute", translations: null },
                metadata: metadata,
                executeTemplate: true,
                doNotUpdateBrowserTitle: false
            } as any;
            sheet.mountContent(ServerTemplateExecuteApp, props);
        });
    }
    // noinspection JSUnusedGlobalSymbols
    openProjectManagementTimes = () => {
        let isDirtyBefore = this.common.entityChanged;
        const sheet = General.Sheet.Manager.createSheetWithUrl(
            Helper.processTemplate('ProjectManagementTimes/Edit?isWindow=true&projNo={{ProjNr}}&pIndex={{PIndex}}&ressnr={{RessNr}}&canWrite=' + this.props.entity.RecordRight.CanWrite,
                (match) => {
                    return encodeURIComponent(this.props.entity[match]);
                })
        );
        sheet.setTitle(this.translations["Beleg.Zeiten"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (data) => {
            MetaDataHelper.setFieldValue(this.props.entity, "entity.Fertig", data.entity.Completion);
            MetaDataHelper.setVisibility(this.props.metadata, "entity.FertigStatistic", false);
            this.setState({}, () => {
                MetaDataHelper.setVisibility(this.props.metadata, "entity.FertigStatistic", true);
                this.setState({});
            });
        });
        sheet.bind(SheetEventType.Close, () => {
            if (isDirtyBefore != this.common.entityChanged)
                this.common.setEntityDirtyState(isDirtyBefore);
        })
    }

    // noinspection JSUnusedGlobalSymbols
    openServiceReports = () => {
        const url = Helper.processTemplate('ServiceReport/Index?isWindow=true&projNr={{ProjNr}}&pIndex={{PIndex}}',
            (match) => {
                return encodeURIComponent(this.props.entity[match]);
            });

        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.setTitle(this.translations["WebSMS.ServiceReport.ServiceReports"]);
        sheet.bind(SheetEventType.Close, this.checkProjectRelease);
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    // noinspection JSUnusedGlobalSymbols
    openGeomap = () => {
        Helper.openInNewBrowserTab(Config.baseUrl + "Directions/Index?type=assignment&id1=" + encodeURIComponent(this.props.entity.ProjNr) + "&id2=" + this.props.entity.PIndex);
    }

    // noinspection JSUnusedGlobalSymbols
    setTravelTimes = (onlyHomewardJourney: boolean) => {
        this.onlyHomewardJourney = onlyHomewardJourney;
        this.geomapService.initializeGoogleMaps(this.calculateTravelTimes);
    }

    // noinspection JSUnusedGlobalSymbols
    rebook = async () => {
        const entityChanged = this.common.entityChanged;
        if (this.common.validate()) {
            if (entityChanged)
                await this.executeSave(false);

            if (this.props.entity.KennungTyp === 4)
                this.setState({ rebook: { projNr: this.state.rebook.projNr, showDialog: true, newKNr: this.state.rebook.newKNr } });
            else
                this.setState({ rebook: { projNr: this.state.rebook.projNr, showDialog: true, newKNr: this.props.entity.KennungObj.KNr } });
        }
    }

    // noinspection JSUnusedGlobalSymbols
    changeAddress = () => {
        this.setState({
            changeAddressDialog: {
                showDialog: true,
                adrNr: this.state.changeAddressDialog.adrNr
            }
        });
    }

    private createChangeAddressDialog = () => {
        const closeDialog = () => {
            this.setState({
                changeAddressDialog: {
                    adrNr: this.state.changeAddressDialog.adrNr,
                    showDialog: false
                }
            });
        }
        let searchFieldProps = this.factory.getDefaultSearchFieldProps();
        searchFieldProps.value = this.state.changeAddressDialog.adrNr;
        searchFieldProps.onChange = (field: { model: string }, value: any) => {
            this.setState({ ...this.state, changeAddressDialog: { adrNr: value, showDialog: true } });
            if (field) {
                //
            }
        }

        searchFieldProps.field.focus = true;
        searchFieldProps.field.searchButtonEnabled = true;
        searchFieldProps.field.searchWindowTitle = this.translations["Adresse.Adresssuche"];
        searchFieldProps.field.searchWindowUrl = "DynamicSearch/Window/Address";

        searchFieldProps.field.autocompleteEnabled = true;

        searchFieldProps.field.autocompleteTemplate = "<table style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top'>${data.AdrNr}</td><td style='vertical-align:top'>${data.AdrName}</td><td style='vertical-align:top'>#=data.Plz != null ? data.Plz : ''#  #=data.Ort != null ? data.Ort : ''#</td></tr></table>";
        searchFieldProps.field.autocompleteUrl = "AddressLookup/Find";
        searchFieldProps.field.autocompleteDataTextField = "AdrNr";
        searchFieldProps.field.listWidth = 650;

        searchFieldProps.onOpened = () => {
            this.setState({ ...this.state, changeAddressDialog: { adrNr: this.state.changeAddressDialog.adrNr, showDialog: false } });
        }


        return (
            <Dialog title={this.translations["WebSMS.ResourcePlanning.ChangeAddress"]}
                open={true} afterClose={closeDialog} actions={this.changeAddressDialogActions}>
                <FieldInstance label={this.translations["Adresse.Adresse"] + "*"} noHover={true}>
                    <IsSearchField {...searchFieldProps} />
                </FieldInstance>
            </Dialog>);
    }

    // noinspection JSUnusedGlobalSymbols
    splitAssignment = async () => {
        const projNr = this.props.entity.ProjNr;
        const pIndex = this.props.entity.PIndex;
        const start = this.props.entity.StartIst;
        const result = await SplittingDialogUtil.openSplittingDialog(projNr, pIndex, start);
        switch (result) {
            case SplittingDialogResult.Success:
                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", doFullRefresh: true });
                break;
            case SplittingDialogResult.NoAssignments:
                NotificationHelper.showInfoMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.NoAssignments"));
                break;
        }


    }

    // noinspection JSUnusedGlobalSymbols
    createTraveldataInfo = () => {
        return (
            <div>
                <TraveldataSummary
                    assignmentTraveldata={this.props.entity.AssignmentTraveldata}
                    continiuesJourney={this.props.entity.ContinuationJourney === 1}
                    firstAssignment={this.props.entity.FirstAssignment === 1}
                    lastAssignment={this.props.entity.LastAssignment === 1}
                    assignmentUtilizationInfo={this.props.entity.AssignmentUtilizationInfo}
                    isContainer={this.props.entity.IsContainerEinsatz}
                    translations={{
                        arbeitsbeginn: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Arbeitsbeginn").name,
                        arbeitsende: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Arbeitsende").name,
                        anfahrt: this.translations["WebSMS.ResourcePlanning.Anfahrt"],
                        auslastung: this.translations["WebSMS.ResourcePlanning.Auslastung"],
                        auslastungunbekannt: this.translations["WebSMS.ResourcePlanning.AuslastungUnbekannt"],
                        erstertag: this.translations["WebSMS.ResourcePlanning.ErsterTag"],
                        gesamttagearbeitszeit: this.translations["WebSMS.ResourcePlanning.GesamtTageArbeitszeit"],
                        letztertag: this.translations["WebSMS.ResourcePlanning.LetzterTag"],
                        luftlinie: this.translations["WebSMS.ResourcePlanning.Luftlinie"],
                        reisedatenfehler: this.translations["WebSMS.ResourcePlanning.ReisedatenFehler"],
                        reisedatenungultig: this.translations["WebSMS.ResourcePlanning.ReisedatenUngultig"],
                        einsatz: this.translations["WebSMS.ResourcePlanning.Einsatz"],
                        ressource: this.translations["WebSMS.ResourcePlanning.Ressource"],
                        zuruck: this.translations["WebSMS.ResourcePlanning.Zuruck"]
                    }}

                />
            </div>
        );
    }

    private createDialog = () => {
        const listBoxAssigmentsProps = this.boxAssigmentsProps();
        return (
            <Dialog title={this.translations["WebSMS.ResourcePlanning.FolgendeEinsaetze"]}
                actions={this.actions} open={true} afterClose={() => { this.dialog() }}>
                <div style={{ width: "800px", height: "450px" }}>
                    <label>{this.translations["WebSMS.ResourcePlanning.WaehleEinsaetze"]}</label>
                    <FieldInstance noHover={true} noLabel={true}>
                        <ListBox ref={this.setListBoxRef}{...listBoxAssigmentsProps} />
                    </FieldInstance>
                </div>
            </Dialog>);
    }

    private createShowConvertedTimesDialog = () => {

        return (
            <Dialog title={Helper.getTranslation("WebSMS.ResourcePlanning.TimeZoneInfo")} actions={this.convertedTimesDialogOptions} open={true} afterClose={this.afterConvertedTimesClose}>
                <TimeZoneSummary
                    adrNr={this.props.entity.AdrNr}
                    arbeitsbeginn={this.props.entity.Arbeitsbeginn}
                    arbeitsende={this.props.entity.Arbeitsende}
                    startIst={this.props.entity.StartIst}
                    endeIst={this.props.entity.EndeIst}
                    pIndex={this.props.entity.PIndex}
                    projNr={this.props.entity.ProjNr}
                    ressNr={this.props.entity.RessNr}
                    translations={{
                        resourceTimeZone: this.translations["WebSMS.ResourcePlanning.ResourceTimeZone"],
                        userTimeZone: this.translations["WebSMS.ResourcePlanning.UserTimeZone"],
                        arbeitsbeginn: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Arbeitsbeginn").name,
                        arbeitsende: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.Arbeitsende").name,
                        startIst: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.StartIst").name,
                        endeIst: MetaDataHelper.getFieldByProperty(this.props.metadata, "model", "entity.EndeIst").name,
                    }}
                />
            </Dialog>
        );
    }

    private createRebookDialog = () => {
        return (
            <Dialog title={this.props.entity.KennungTyp === 4 ? this.translations["Einsatz.Rebook.RebookOnProject"] : this.translations["Einsatz.Rebook.RebookOnAnotherProject"]}
                actions={this.rebookDialogActions}
                open={this.state.rebook.showDialog}
                afterClose={() => { this.setState({ ...this.setState, rebook: { showDialog: false, projNr: "", newKNr: null } }) }}
            >
                <div style={{ width: "500px" }}>
                    <FieldInstance label={this.translations["Field.Einsatz.projnr"]} noHover={true}>
                        <IsSearchField {... this.getSearchFieldProps()} />
                    </FieldInstance>
                </div>
                {(this.props.entity.KennungTyp === 4) ?
                    <div style={{ width: "500px" }}>
                        <FieldInstance label={this.translations["Field.Einsatz.kennung"] + "*"} noHover={true}>
                            <DropDownList {... this.getDropDownListProps()} />
                        </FieldInstance>
                    </div>
                    : null}
            </Dialog>
        );
    }

    save = async (closeAfterSave: boolean) => {
        if (this.common.validate()) {
            if (this.resetApprovalRequired()) {
                let isOk = await DialogHelper.confirm(this.translations["WebSMS.ResourcePlanning.ShouldResetApproval"].replace("{projNr}", this.props.entity.ProjNr).replace("{pIndex}", this.props.entity.PIndex.toString()));

                if (isOk) {
                    this.resetApproval(() => {
                        this.executeSave(closeAfterSave);
                    });
                }
            } else {
                await this.executeSave(closeAfterSave);
            }
        }
    }

    // noinspection JSUnusedGlobalSymbols
    openConvertedTimes = () => {
        this.setState({ showConvertedTimesDialog: true });
    }

    // noinspection JSUnusedGlobalSymbols
    useStandardWorkingTime = async () => {
        await this.reloadWorkingTime(this.props.entity.IsContainerEinsatz ? null : this.props.entity.RessNr, false);
    }

    private initApp = async () => {
        this.oldData = this.props.entity;
        this.oldStart = this.props.entity.IsNew ? null : this.props.entity.StartIst;
        this.oldEnd = this.props.entity.IsNew ? null : this.props.entity.EndeIst;
        this.oldResourceId = Helper.hasValue(this.props.entity.RessNr) ? "r|" + this.props.entity.RessNr : "g|" + this.props.entity.GrNr;
        this.oldId = this.props.entity.ProjNr + "|" + this.props.entity.PIndex
        this.calculateIsMultipleDaysAssignment(this.props.entity.Arbeitsbeginn, this.props.entity.Arbeitsende);
        const externalData = General.Sheet.Manager.getTopMostSheet().getExternalData();
        if (Helper.hasValue(externalData) && externalData.forceReadOnly === true) {
            this.props.entity.RecordRight.CanWrite = false;
        }
        this.showAlternateCommentField = !Helper.hasValue(this.props.entity.PIndexView) || Helper.isNullOrEmpty(this.props.entity.PIndexView.toString())

        this.geomapEnabled = this.props.configData.geomapEnabled;
        this.timeZonesEnabled = this.props.configData.timeZoneEnabled;


        if (this.props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(this.releaseLock);
        } else {
            //if (this.common.modalContainer)
            //    this.common.modalContainer.one("deactivate", cleanUpOnClose);
        }

        if (this.props.entity.RecordRight.CanWrite && !this.props.entity.IsNew && this.props.entity.KennungObj != null) {
            this.getApprovalConfig(this.props.entity.ProjNr, this.props.entity.KennungObj.KNr);
        }
        if (this.props.entity.IsNew)
            this.props.configData.workHours = this.props.entity.Arbeitszeit;

        this.props.context.materialGrid = this.articleGridOptions;
        this.props.context.machineGrid = this.machineGridOptions;
        this.actions = this.getDialogeActions();
        General.Events.bind(EventType.SavedSuccessfully, (data: { entity: { AdrNr: string, TimeZone: string }, context: any }) => {
            if (data.context === "address") {
                let newEntity = this.props.entity;
                newEntity.AddressTimeZone = data.entity.TimeZone;
                Helper.updateEntity(this.props.entity, newEntity);
                this.setState({});
            }
        });

        await this.getAssignmentCodes();
        await this.handleFieldChange({ model: "entity.KennungTypeWithKey" }, this.props.entity.KennungTypeWithKey, null, true);
        await this.handleFieldChange({ model: "entity.Arbeitszeit" }, this.props.entity.Arbeitszeit, null, true);
        await this.handleFieldChange({ model: "entity.DauerInMonaten" }, this.props.entity.DauerInMonaten, null, true);
        await this.handleFieldChange({ model: "entity.EndeIst" }, this.props.entity.EndeIst, null, true);
        await this.handleFieldChange({ model: "entity.IsContainerEinsatz" }, this.props.entity.IsContainerEinsatz, null, true);
        await this.handleFieldChange({ model: "entity.ProjNr" }, this.props.entity.ProjNr, null, true);
        //this.handleFieldChange({ model: "entity.KennungTyp" }, this.props.entity.KennungTyp, null, true);

        //if (this.timeZonesEnabled) {
        //    if (this.common.modalContainer)
        //        this.common.modalContainer.setOptions({ "minWidth": "1050px" });
        //}



    }

    private calculateIsMultipleDaysAssignment(arbeitsbeginn: string, arbeitsende: string) {
        if (Helper.hasValue(this.props.entity.Arbeitsbeginn) && Helper.hasValue(this.props.entity.Arbeitsende)) {
            const startDate = kendo.parseDate(arbeitsbeginn);
            const endDate = kendo.parseDate(arbeitsende);
            const start = startDate.getTime();
            const end = endDate.getTime();
            const hoursDiff = (end - start) / 3.6e6;

            if (Config.settings.einfacheKapazitaetsberechnung) {
                this.isMultipleDaysAssignment = true;
            }
            else {
                if (hoursDiff <= 0) {
                    this.isMultipleDaysAssignment = null;
                }
                else
                    this.isMultipleDaysAssignment = hoursDiff > 24;
            }
        }
        else {
            this.isMultipleDaysAssignment = null;
        }
    }

    componentDidMount() {
        if (this.props.entity.RecordRight.CanWrite && this.defined(this.props.entity.IsId) && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.IsId, "PLANUNG", 10000);
        }

        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, async (cus) => {
            if (cus.command === "documentsChanged") {
                let result = await HTTPService.get<JsonResultClass<Array<{ Dokuid: number, ToBeSend: boolean }>>>("ResourcePlanningLookup/GetDelegationDocumentsWithSendStatus?projNr=" + encodeURIComponent(this.props.entity.ProjNr) + "&pIndex=" + this.props.entity.PIndex);
                if (result.Code > 0) {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                else {
                    await this.handleDisableSendState();
                    this.common.handleFieldChange({ model: "entity.DocumentsToBeSend" }, result.Data);
                    NotificationHelper.showInfoMessage(this.translations["WebSMS.ResourcePlanning.DocumentsToBeSendUpdated"]);
                }
                await this.refreshSendState();
            }
            if (cus.command === "expensesChanged") {
                await this.handleFieldChange({ model: "Spesen" }, cus.value);
            }
            if (cus.command === "overnightStayChanged") {
                await this.handleFieldChange({ model: "Uebernachtung" }, cus.value);
            }
            if (cus.command === "houlyRateChanged") {
                await this.handleFieldChange({ model: "Stundensatz" }, cus.value);
            }
            if (cus.command === "refreshSendState") {
                await this.refreshSendState();
            }
        });


        General.Events.bind(EventType.Custom, (data: { cmd: string, data: any }) => {
            switch (data.cmd) {
                case "changedAdrNrFuture":
                    if (kendo.parseDate(this.props.entity.StartIst) > new Date()) {
                        this.handleFieldChange({ model: "entity.AdrNr" }, data.data).then();
                        this.refreshSendState();
                    }
                    break;
                case "changedAdrNr":
                    this.handleFieldChange({ model: "entity.AdrNr" }, data.data).then();
                    this.refreshSendState();
                    break;
            }
        });
    }

    componentWillUnmount() {
    }


    private canShowPreview = () => {
        let tmp = false;
        if (this.state.selectedDocsToSend.length == 1)
            tmp = this.state.selectedDocsToSend[0].Dokutyp != 5 && this.state.selectedDocsToSend[0].Dokutyp != 9
        return tmp;
    }

    // noinspection JSUnusedGlobalSymbols
    renderDocumentsToBeSend = () => {
        const canShowPreview = this.canShowPreview();
        const buttons: GridCustomToolBarButton[] = [
            {
                autoEnabledOnRecordSelected: true,
                caption: "Download",
                enabled: this.state.selectedDocsToSend.length > 0,
                iconClass: "fa-light fa-download",
                id: this.downloadBtnId
            },
        ];
        if (this.state.selectedDocsToSend.length == 1 && this.state.selectedDocsToSend[0].Dokutyp == 5) {
            buttons.push({
                autoEnabledOnRecordSelected: true,
                caption: Helper.getTranslation("Standard.Öffnen"),
                enabled: true,
                iconClass: "fa-light fa-arrow-up-right-from-square",
                id: this.openLinkBtnId
            });
        } else {
            buttons.push({
                autoEnabledOnRecordSelected: true,
                caption: canShowPreview && this.state.showPreview ? Helper.getTranslation("WebSMS.Documents.HidePreview") : Helper.getTranslation("WebSMS.Documents.ShowPreview"),
                enabled: canShowPreview,
                iconClass: "fa-light fa-eye",
                id: this.previewBtnId
            });
        }

        const data = this.props.entity.DocumentsToBeSend.filter(doc => !doc.OnlyIntern);
        if (data.length > 0) {


            const showSelectAll = data.filter(doc => !doc.ToBeSend).length > 0;
            if (showSelectAll) {
                buttons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: Helper.getTranslation("Standard.SelectAll"),
                    enabled: true,
                    iconClass: "fa-light fa-check-double",
                    id: this.selectAllId
                });
            } else {
                buttons.push({
                    autoEnabledOnRecordSelected: false,
                    caption: Helper.getTranslation("Standard.DeselectAll"),
                    enabled: true,
                    iconClass: "fa-light fa-x",
                    id: this.deselectAllId
                });
            }
        }


        let preview = null;
        if (canShowPreview && this.state.showPreview) {
            const file = this.state.selectedDocsToSend[0];
            preview = <DocumentPreview filename={file.FileName} dokuGuid={file.Isguid} additionalUrlParams={null} />
        }
        return (
            <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={67} >
                <Grid
                    throttleActive={false}
                    id="resourcePlanningDocsToSend"
                    data={data}
                    options={this.documentsToBeSendGridOptions}
                    onSelectionChanged={(data: any | any[]) => {
                        let selectedDocsToSend = [];
                        if (!Array.isArray(data)) {
                            selectedDocsToSend = [data]
                        } else if (Helper.hasValue(data)) {
                            selectedDocsToSend = data;
                        }
                        let showPreview = selectedDocsToSend.length > 1 ? false : this.state.showPreview;
                        if (selectedDocsToSend.length == 1 && Helper.hasValue(selectedDocsToSend[0])) {
                            showPreview &&= selectedDocsToSend[0].Dokutyp != 5 && selectedDocsToSend[0].Dokutyp != 9
                        }

                        selectedDocsToSend = selectedDocsToSend.filter(doc => Helper.hasValue(doc))
                        this.setState({ selectedDocsToSend: selectedDocsToSend, showPreview: showPreview })
                    }}
                    onDataBound={
                        (e) => {
                            $(e.sender.wrapper).on("click", ".checkboxTable", async (ev) => {
                                // Checkbox ToBeSend auswerten und Model DocumentsToBeSend aktualisieren
                                const $target = $(ev.target);
                                const checked = $target.is(":checked");

                                const dataItem = e.sender.dataItem($target.closest("tr"));
                                let found = false;
                                let i = 0;
                                if (dataItem !== undefined) {
                                    while (!found && i < this.props.entity.DocumentsToBeSend.length) {
                                        if (this.props.entity.DocumentsToBeSend[i].Dokuid === dataItem.get("Dokuid")) {
                                            this.props.entity.DocumentsToBeSend[i].ToBeSend = checked;
                                            found = true;
                                        }
                                        i++;
                                    }
                                    await this.handleDisableSendState();
                                    this.common.handleFieldChange({ model: "entity.DocumentsToBeSend" }, this.props.entity.DocumentsToBeSend);
                                }
                            });
                        }
                    }
                    customButtons={buttons}
                    onClickCustomButton={this.onBtnClick}
                />
                {preview}
            </RSplitter>
        );
    }

    private onBtnClick = (id: string) => {
        const data = this.props.entity.DocumentsToBeSend;

        switch (id) {
            case this.downloadBtnId:

                if (this.state.selectedDocsToSend.length == 1) {
                    const item = this.state.selectedDocsToSend[0]
                    Helper.download(`${Config.baseUrl}Document/Download/${item.Isguid}`, "newFile");
                } else if (this.state.selectedDocsToSend.length > 1) {
                    const ids = this.state.selectedDocsToSend
                        .filter(dts => (dts.Dokutyp != 5 && dts.Dokutyp != 9))
                        .map(x => x.Isguid)
                        .join(";")
                    const url = `${Config.baseUrl}Document/DownloadFiles?ids=${ids}`;
                    Helper.openInNewBrowserTab(url);
                }
                break;
            case this.previewBtnId:
                this.setState({ showPreview: !this.state.showPreview })
                break;
            case this.openLinkBtnId:
                Helper.openInNewBrowserTab(this.state.selectedDocsToSend[0].Verzeichnis)
                break;
            case this.selectAllId:
                for (let i = 0; i < data.length; i++) {
                    data[i].ToBeSend = true;
                }
                this.handleFieldChange({ model: "entity.DocumentsToBeSend" }, data).then();
                break;
            case this.deselectAllId:
                for (let i = 0; i < data.length; i++) {
                    data[i].ToBeSend = false;
                }
                this.handleFieldChange({ model: "entity.DocumentsToBeSend" }, data).then();
                break;
        }
    }

    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }
    remove = async () => {
        let entity = {
            ...this.props.entity,
            KNr: this.props.entity.KennungObj?.KNr
        };
        let assignmentDeleted = (multiple: boolean) => {
            let sheet = General.Sheet.Manager.getTopMostSheet();
            sheet.trigger(SheetEventType.Custom, { command: "reloadExecutionInfo" });
            if (this.common.isWindow) {
                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted);
                this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "partialRefresh", projnr: this.props.entity.ProjNr, pindex: this.props.entity.PIndex, doFullRefresh: multiple });
                this.common.sheetWrapper.hide();
            } else {
                this.deleteEnabled = false;
                this.isDeleted = true;
                this.props.entity.RecordRight.CanWrite = false;
                this.setState({});
            }
        };
        await OpenResourcePlanningDeletionDialog(entity, assignmentDeleted);
    }

    // noinspection JSUnusedGlobalSymbols
    newAssigmentGrouping = () => {
        HTTPService.get<JsonResultClass>("ResourcePlanning/GetNewGroupingId")
            .then(result => {
                if (result.Code === 0) {
                    this.props.entity.Gruppierung = result.Data;
                    this.setState({});
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    // noinspection JSUnusedGlobalSymbols
    listAssigmentGrouping = async () => {
        if (this.props.entity.Gruppierung > 0) {

            if (this.common.validate()) {
                if (this.resetApprovalRequired()) {
                    let isOk = await DialogHelper.confirm(this.translations["WebSMS.ResourcePlanning.ShouldResetApproval"].replace("{projNr}", this.props.entity.ProjNr).replace("{pIndex}", this.props.entity.PIndex.toString()));
                    if (isOk) {
                        this.resetApproval(() => {
                            this.executeSave(false, true, false);
                        });
                    }
                } else {
                    await this.executeSave(false, false, false);
                }
            }


            const url = "ResourcePlanning/ResourcePlanningGroupingList";
            const titleEx = this.saveSheetTitle;

            const sheet = General.Sheet.Manager.createSheetWithUrl(url, { "grouping": this.props.entity.Gruppierung, "projNr": this.props.entity.ProjNr, "pIndex": this.props.entity.PIndex, "title": titleEx }, null, true);
            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                this.setState({});
            });

        }
    }

    // noinspection JSUnusedGlobalSymbols
    copyAssignmentToResources = () => {
        let url = "DynamicSearch/Window/Resource?cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus&withSkills=true&multi=true&displayPattern=[[name]] [[vorname]]";
        if (Helper.hasValue(this.props.entity.ProjNr) && Helper.hasValue(this.props.entity.PIndex))
            url = url + `&projnr=${encodeURIComponent(this.props.entity.ProjNr)}&pindex=${this.props.entity.PIndex}`;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<any> }) => {
            const newResourceIds = [];
            e.data.forEach(data => {
                newResourceIds.push("r|" + data.ressnr);
            });
            if (newResourceIds.length > 0) {
                const ressourceId = this.props.entity.IsContainerEinsatz ?
                    "g|" + this.props.entity.RessNr : "r|" + this.props.entity.RessNr;
                const copyGrouped = this.assignmentGroupingActive && this.copyRessourceGroupingActive &&
                    await ResourcePlaningGroupingHelper.checkCopyGrouped(
                        this.props.entity.ProjNr, this.props.entity.PIndex, ressourceId, this.props.entity.Gruppierung, newResourceIds);

                HTTPService.post("ResourcePlanning/CopyAssignment", {
                    projNr: this.props.entity.ProjNr,
                    pIndex: this.props.entity.PIndex,
                    newResourceIds: newResourceIds,
                    copyGrouped: copyGrouped
                }).then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.sheetWrapper.trigger(SheetEventType.Custom, {
                        command: "partialRefresh",
                        doFullRefresh: true
                    });
                });
            }
        });
        General.Functions.HistoryState.pushSheetState(sheet, url);
        this.setState({});
    }

    private onTreeDataChanged = (treeData: TreeNodeVm[]) => {
        let skillCategories = SkillHelper.getAllSkillCategories(treeData);
        this.setState({ skillsChanged: true, currentSkills: skillCategories });
        this.common.setEntityDirtyState(true);
    }

    // noinspection JSUnusedGlobalSymbols
    createSkills = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="assignment" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["WebSMS.Skills.Skills"]} useSkillProfile={true} />;
    }

    // noinspection JSUnusedGlobalSymbols
    releaseForMobileFieldService = async () => {
        await this.handleFieldChange({ model: "entity.Statussend" }, 1);
        await this.save(false);
    }

    // noinspection JSUnusedGlobalSymbols
    resetForMobileFieldService = async () => {
        let isOk = await OpenResourcePlanningResetSendStateDialog(this.props.entity, Helper.getTranslation("Field.Einsatz.RevokeStatusSend"));
        if (isOk) {
            await this.handleFieldChange({ model: "entity.Statussend" }, null);
            await this.save(false);
        }
    }

    render() {
        this.props.dataSources.assignmentTypesDS = [{ text: this.translations["Ressource.Ressource"], value: false }, { text: this.translations["Einsatz.Container"], value: true }];
        this.props.dataSources.assignmentCodesDS = this.assignmentCodesDS;
        //this.props.dataSources.pIndexViewDataSource = this.pIndexViewDataSource;

        const dialog = (this.state.showDialog && Config.user.splitUpAndCutAssignment) ? this.createDialog() : null;
        const showConvertedTimesDialog = this.state.showConvertedTimesDialog ? this.createShowConvertedTimesDialog() : null;
        const rebookDialog = this.state.rebook.showDialog ? this.createRebookDialog() : null;
        const changeAddressDialog = this.state.changeAddressDialog.showDialog ? this.createChangeAddressDialog() : null;

        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });

        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: `${this.props.entity.ProjNr} / ${this.props.entity.PIndex}`,
            locked: this.defined(this.props.entity.LockMessage) && this.props.entity.LockMessage.trim() !== "",
            lockInfo: this.props.entity.LockMessage
            //title={"Folgende Einsätze sind aufgrund der erstellten Abwesenheit gefährdet:"titel={this.translations["WebSMS.ResourcePlanning.FolgendeEinsaetze"]}
        };

        this.saveSheetTitle = props.sheetTitle;

        return (
            <>
                <CommonApp {...props} titleProps={titleProps} />
                {dialog}
                {showConvertedTimesDialog}
                {rebookDialog}
                {changeAddressDialog}
            </>);
    }
};

enum ApprovalFields {
    Resource, PeriodStart, PeriodEnd, TextActivity, TextRemark
}

interface ResourcePlanningState {
    showDialog: boolean;
    showConvertedTimesDialog: boolean;
    rebook: Rebook;
    changeAddressDialog: {
        showDialog: boolean;
        adrNr: string;
    };
    movedGroupingArray: any[];
    skillsChanged?: boolean;
    currentSkills?: SkillCategory[];
    selectedDocsToSend?: any[];
    showPreview?: boolean;
}

interface Rebook {
    showDialog: boolean;
    projNr: string;
    newKNr: number;
}

enum StartEditingStuff {
    None = 0,
    OnlyWorkStart = 1,
    TravelAndWorkStart = 2
}

export interface ResourcePlanningAppProps extends AppBaseProps {
    entity: ResourcePlanningEntity;
    context: ResourcePlanningContext;
    configData: ResourcePlanningAppConfigData;
    adjustMaingroupAtNewAssignment?: boolean;
}

interface ResourcePlanningContext extends Context {
    materialGrid: {};
    machineGrid: {};
}

interface ApprovalRequirements {
    Level: number;
    Resource: boolean;
    Texts: boolean;
    Period: boolean;
    ProjectLevelUsed: boolean;
}

interface ResourcePlanningAppConfigData {
    workHours: number;
    pmLink?: number;
    geomapEnabled: boolean;
    timeZoneEnabled: boolean;
    approvalLevel: number;
    assignmentGroupingActive: boolean;
    copyRessourceGroupingActive: boolean;
}
export interface ResourcePlanningEntity extends Entity {
    ProjNr: string;
    PIndex: number;
    KennungTypeWithKey: string;
    AdrNr: string;
    RessNr: string;
    EndeIst: string;
    StartIst: string;
    Arbeitsbeginn: string;
    Arbeitsende: string;
    KennungTyp: number;
    HalberTag: boolean;
    Arbeitszeit: number;
    Kennung: string;
    PercentageWork: number;
    PercentageWorkDisplay: string;
    DauerInMonaten: number;
    ProjNr2: string;
    Database: string;
    IsContainerEinsatz: boolean;
    IsId?: number;
    LockMessage?: string;
    Approvals?: number;
    Statussend?: number;
    NotificationState?: string;
    KennungObj?: {
        KNr: number;
    }
    IsRebookable: boolean;
    DocumentsToBeSend: Array<{ Dokuid: number, ToBeSend: boolean, IsProjectDoc: boolean, Dokutyp: number, OnlyIntern: boolean }>;
    GrNr: number;
    OGrNr: number;
    GruppeName: string;
    ReportAcquisition: boolean;
    Ticket?: number;
    Kopplung: boolean;
    PIndexView?: number;
    Auftragsnummer: number;
    AddressTimeZone: string;
    IsGuid: string;
    Gruppierung: number;
    LastAssignment: number;
    RessourceFixiert?: boolean;
    ContinuationJourney: number;
    AssignmentTraveldata?: AssignmentTraveldataModel;
    CreateLogin?: string;
    CreateDate?: Date;
    ChangeLogin?: string;
    ChangeDate?: Date;
    FirstAssignment: number;
    AssignmentUtilizationInfo?: AssignmentUtilizationInfo;
    Fertig?: number;
    IsMobileUser?: boolean;
    UsesWindowsClient?: boolean;
    Datenpaket: string;
    Vorlaufzeit?: number;
    IsSendToMobileApp: boolean;
    Spesen?: number;
    Uebernachtung?: number;
    Stundensatz?: number;
    Reisekosten?: number;
    Kennwort?: string;
}

export interface AssignmentTraveldataModel {
    projNr: string;
    pIndex: number;
    traveldataInfo?: TraveldataInfoModel;
    assignmentTimes?: AssignmentTimesModel;
    wayThere?: TraveldataModel;
    wayBack?: TraveldataModel;
}

export interface AssignmentTimesModel {
    arbeitsBeginn: string;
    arbeitsEnde: string;
    workPerDay: number;
    startIst: string;
    endeIst: string;
}

export interface TraveldataInfoModel {
    backHome: boolean;
    fromHome: boolean;
    fromInfo: string;
    backInfo: string;
    summary: string;
    valid: boolean;
}

export interface TraveldataModel {
    isGuid: string;
    assignmentGuid: string;
    travelType: string;
    requestTime: string;
    distance: number;
    time: number;
    summary: string;
    startFrom: string;
    endTo: string;
    ressNr: string;
    journeyLeg: JourneyLegModel;
    prevAssignmentId: string;
}

export interface JourneyLegModel {
    DistanceKm: number;
    DurationHours: number;
    StartPoint: PointModel;
    EndPoint: PointModel;
    Kind: 0 | 1 | 2 | 3;
}

interface PointModel {
    lat: number;
    long: number;
}